import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit, OnChanges {

  @Input() name;
  @Input() size;
  @Input() profilePhoto = null;
  @Input() hideName = false;
  public showName: boolean = false;
  public showPic: boolean = false;
  public backgroundColor: string = "#181818";
  public outerSize: Number = 0;

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges() {
    this.showPic = false;
    this.showName = false;
    this.outerSize = parseInt(this.size) + 2;
    if (this.profilePhoto && this.profilePhoto.indexOf('avatar1') === -1) {
      this.showPic = true;
    } else {
      this.showName = true;
      this.backgroundColor = this.intToRGB(this.hashCode(this.name));
    }
  }

  getInitial(name) {
    if (!this.hideName) {
      if (name) {
        var names = name.trim().split(' ');
        if (names.length >= 2) {
          return names.map(n => {
            return n[0] !== undefined ? n[0].toUpperCase() : n[0];
          }).join('');
        } else {
          return name.substring(0, 2) !== undefined
            ? name.substring(0, 2).toUpperCase()
            : name.substring(0, 2);
        }
      } else {
        return 'NA';
      }
    }
  };

  hashCode(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();

    return '00000'.substring(0, 6 - c.length) + c;
  }
}
